export const delayWithCancel = (ms: number) => {
  let cancel: () => void = () => {};
  const promise = new Promise<void>(resolve => {
    const timeoutId = setTimeout(resolve, ms);
    cancel = () => {
      clearTimeout(timeoutId);
      resolve();
    };
  });
  return { promise, cancel };
};
